import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { SharedService } from "src/app/shared/services/shared.service";
import { CustomInfluenzaService } from "../custom-influenza.service";


@Component({
  selector: 'app-flu-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './flu-header.component.html',
  styleUrls: ['./flu-header.component.scss']
})
export class FluHeaderComponent implements OnInit,OnChanges {
  @Input() selectedHeader: string;
  @Input() tableCategory: string;
  @Input() isStsEligible: boolean = false;
  asmFlag: boolean = false; //default false
  constructor(private readonly influenzaService:CustomInfluenzaService,
    private readonly sharedService: SharedService,
    private readonly ref: ChangeDetectorRef) { }

  ngOnInit() {
    //subscription to show shipping schedule tab or not
    // this.influenzaService.setShippingSchedule.subscribe((data) => {
    //   if (data) {
    //     this.asmFlag = data;
    //   }
    // });
    this.asmFlag = this.sharedService.getSessionStorage('isStsEligible');
  }
  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(this.isStsEligible){
      this.asmFlag = this.sharedService.getSessionStorage('isStsEligible');
      this.ref.detectChanges();
    }
  }

}
